(function($) {
  
  function wrap_text_in_spans(ele){
    var words = ele.text().split("");
    ele.empty();
    $.each(words, function(i, v) {
        if(v===' '){
            ele.append('<span>&nbsp;</span>');
        } else {
            ele.append($("<span>").text(v));
        }
    });
  }

  wrap_text_in_spans($("footer .blob .content p"));  
       
})( jQuery );